/**
 * PresenceBar — kleine Avatar-Reihe oben rechts im Viewer, zeigt alle
 * User, die gerade dasselbe Projekt offen haben. Daten kommen aus dem
 * useProjectPresenceStore, der via useProjectLiveUpdates befüllt wird.
 */

import { useProjectPresenceStore, type PresenceUser } from '../../store/presence'
import { useAuthStore } from '../../store/auth'
import { useViewerSyncStore } from '../../store/viewerSync'
import { UserAvatar, MAX_VISIBLE } from './UserAvatar'

export function PresenceBar() {
  const users = useProjectPresenceStore((s) => s.users)
  const myId = useAuthStore((s) => s.user?.id)
  const followingUserId = useViewerSyncStore((s) => s.followingUserId)
  const setFollowing = useViewerSyncStore((s) => s.setFollowing)

  if (users.length === 0) return null

  const handleAvatarClick = (u: PresenceUser) => {
    if (u.id === myId) return  // sich selbst verfolgen ergibt keinen Sinn
    setFollowing(followingUserId === u.id ? null : u.id)
  }

  // Eigenen User zuerst, dann der Rest stabil nach Name
  const sorted = [...users].sort((a, b) => {
    if (a.id === myId) return -1
    if (b.id === myId) return 1
    return (a.username || '').localeCompare(b.username || '')
  })
  const visible = sorted.slice(0, MAX_VISIBLE)
  const overflow = sorted.length - visible.length

  return (
    <div
      style={{
        position: 'fixed', top: 8, right: 8, zIndex: 11000,
        display: 'flex', gap: 4, padding: 4,
        background: 'rgba(255,255,255,0.85)',
        backdropFilter: 'blur(8px)',
        borderRadius: 999,
        boxShadow: '0 2px 12px rgba(0,0,0,0.12)',
        pointerEvents: 'auto',
      }}
    >
      {visible.map((u) => {
        const isFollowed = u.id === followingUserId
        const isMe = u.id === myId
        return (
          <button
            key={u.id}
            type="button"
            onClick={() => handleAvatarClick(u)}
            title={isMe ? undefined : isFollowed ? 'Verfolgung beenden' : `${u.firstName ?? ''} ${u.lastName ?? ''} (${u.email}) — klicken zum Verfolgen`.trim()}
            disabled={isMe}
            style={{
              border: isFollowed ? '2px solid #1a1a1a' : 0,
              background: 'transparent', padding: 0, borderRadius: '50%',
              cursor: isMe ? 'default' : 'pointer',
              opacity: isMe ? 0.95 : 1,
            }}
          >
            <UserAvatar user={u} highlight={isMe} />
          </button>
        )
      })}
      {overflow > 0 && (
        <div
          title={`+${overflow} weitere`}
          style={{
            width: 28, height: 28, borderRadius: '50%',
            background: '#e2e8f0', color: '#475569', fontSize: 11, fontWeight: 600,
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          }}
        >+{overflow}</div>
      )}
    </div>
  )
}
